export default function EditIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2601 3.59924L5.0501 12.2892C4.7401 12.6192 4.4401 13.2692 4.3801 13.7192L4.0101 16.9592C3.8801 18.1292 4.7201 18.9292 5.8801 18.7292L9.1001 18.1792C9.5501 18.0992 10.1801 17.7692 10.4901 17.4292L18.7001 8.73924C20.1201 7.23924 20.7601 5.52924 18.5501 3.43924C16.3501 1.36924 14.6801 2.09924 13.2601 3.59924Z"
        strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.8899 5.05078C12.3199 7.81078 14.5599 9.92078 17.3399 10.2008" strokeWidth="1.5"
            strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 22H21" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
  )
}
